module.exports = __webpack_public_path__ + "img/training_mix5.0ffae1e5.jpg";